import { Link } from 'react-router-dom';

import pt from '../../locales/pt';
import { paths } from '../../routes/paths';

function displayName(profile, user) {
  const name = profile?.full_name?.trim();
  if (name) return name;
  const email = user?.email || '';
  const local = email.split('@')[0] || '';
  if (!local) return pt.settings.hub.anonymousName;
  return local.charAt(0).toUpperCase() + local.slice(1);
}

function avatarInitial(profile, user) {
  const name = displayName(profile, user);
  return name.charAt(0).toUpperCase();
}

export function SettingsAccountHeader({ profile, user }) {
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-border bg-card px-4 py-4">
      <span
        className="flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-[15px] bg-sage-600 font-display text-xl font-bold text-white"
        aria-hidden
      >
        {avatarInitial(profile, user)}
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate font-display text-base font-bold text-foreground">
          {displayName(profile, user)}
        </p>
        <p className="truncate text-xs text-muted-foreground">{user?.email}</p>
      </div>
      <Link
        to={paths.settingsProfile}
        className="shrink-0 text-xs font-semibold text-sage-700 hover:underline dark:text-sage-400"
      >
        {pt.settings.hub.editProfile}
      </Link>
    </div>
  );
}
